import React, { useEffect, useState } from 'react';
import s from "./UserForm.module.css"
import { useFormik } from 'formik';
import { useUser } from '../../Context/UserContext';
import { getFormattedDeviceList } from '../../Api//DevicesApi'
import { getUserByEmail, editUser } from '../../Api//UserApi'
import { SubmitButtonForm } from '../shared/SubmitButtonForm'
import { TextField, FormControl, InputLabel, MenuItem, Typography, Autocomplete } from '@mui/material';
import { ROLES } from '../../constants/constants';
import { FormTextField } from '../shared/FormTextField';
import { FormSelect } from '../shared/FormSelect';

export const EditForm = ({ email, onSuccess }) => {
    const { user } = useUser();
    const [devices, setDevice] = useState([]);


    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        const fetchDevices = async () => {
            try {
                const formatted = await getFormattedDeviceList();
                setDevice(formatted);
            } catch (error) {
                console.error('Error fetching devices:', error.message);
            }
        };

        fetchDevices();
    }, []);

    const formik = useFormik({
        initialValues: {
            email: "",
            fullname: "",
            phonenumber: "",
            role: "",
            organization: [],
            group: [],
            device: []
        },
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);
            try {
                const data = await editUser(email, values);
                setSubmitStatus('success');
                if (onSuccess) onSuccess();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        },
        enableReinitialize: true,
    })


    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getUserByEmail(email);

                formik.setValues({
                    email: data.email,
                    fullname: data.fullname,
                    phonenumber: data.phonenumber,
                    role: data.role,
                    organization: data.organization.map(item => item._id) || [],
                    group: data.group.map(item => item._id) || [],
                    device: data.device || []
                });

            } catch (error) {
                console.error('Failed to fetch user data:', error.message);
            }
        };

        fetchData();
    }, []);



    let availableRoles = [];
    switch (user.role) {
        case 'ADMIN_CHIRPSTACK':
            availableRoles = ROLES;
            break;
        case 'ADMIN_SERVER':
            availableRoles = ROLES.filter(role => role.value !== 'ADMIN_CHIRPSTACK');
            break;
        case 'ADMIN_ORG':
            availableRoles = ROLES.filter(role => !['ADMIN_CHIRPSTACK', 'ADMIN_SERVER'].includes(role.value));
            break;
        case 'ADMIN_VODOKANAL':
            availableRoles = ROLES.filter(role => !['ADMIN_CHIRPSTACK', 'ADMIN_SERVER', 'ADMIN_ORG'].includes(role.value));
            break;
        case 'USER_ORG':
            availableRoles = ROLES.filter(role => !['ADMIN_CHIRPSTACK', 'ADMIN_SERVER', 'ADMIN_ORG', 'ADMIN_VODOKANAL', 'SETTING_ORG'].includes(role.value));
            break;
        default:
            availableRoles = [];
    }

    const handleFormClick = (event) => {
        event.stopPropagation();
    };

    return (
        <form onSubmit={formik.handleSubmit} onClick={handleFormClick}>
            <Typography variant="h4">
                Редактировать
            </Typography>

            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{s.errorMessage}</div>}
            <FormTextField formik={formik} name={"email"} value={formik.values.email} label={"Электронная почта"} />
            <FormTextField formik={formik} name={"fullname"} value={formik.values.fullname} label={"ФИО"} />
            <FormTextField formik={formik} name={"phonenumber"} value={formik.values.phonenumber} label={"Телефон"} />
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Роль пользователя</InputLabel>
                <FormSelect formik={formik} name={"role"} label="Роль пользователя" value={formik.values.role}>
                    {availableRoles.map(role => (
                        <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>
                    ))}
                </FormSelect>
            </FormControl>
            {formik.values.role === 'USER' && (
                <Autocomplete
                    sx={{ marginTop: '16px' }}
                    multiple
                    id="tags-outlined"
                    options={devices}
                    getOptionLabel={(option) => `${option?.dev_number || ''} - ${option?.address || ''}`}
                    filterSelectedOptions
                    value={formik.values.device.map(id => devices.find(d => d.dev_id === id)) || []}
                    onChange={(event, value) => {
                        formik.setFieldValue('device', value.map(item => item.dev_id));
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Устройства"
                            placeholder="Выберите устройства"
                        />
                    )}
                />
            )}
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Организация</InputLabel>
                <FormSelect formik={formik} name={"organization"} label="Организация" value={formik.values.organization} multiple>
                    {user.organization.map(org => (
                        <MenuItem value={org.id} key={org.id}>{org.name}</MenuItem>
                    ))}
                </FormSelect>
            </FormControl>
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Группа устройств</InputLabel>
                <FormSelect formik={formik} name={"group"} label="Группа устройств" value={formik.values.group} multiple>
                    {user.group.map(group => (
                        <MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>
                    ))}
                </FormSelect>
            </FormControl>
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>

    );
};